import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import ThemesStrip from "@/components/site/ThemesStrip";
import AboutBook from "@/components/site/AboutBook";
import SamplePoems from "@/components/site/SamplePoems";
import Author from "@/components/site/Author";
import ReaderReviews from "@/components/site/ReaderReviews";
import ClosingCta from "@/components/site/ClosingCta";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#fdfbf7] paper-grain">
      <Navbar />
      <main>
        <Hero />
        <ThemesStrip />
        <AboutBook />
        <SamplePoems />
        <Author />
        <ReaderReviews />
        <ClosingCta />
      </main>
      <Footer />
    </div>
  );
}
